var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 105.5 154.1",
    style: {
      enableBackground: "new 0 0 105.5 154.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:none;stroke:#222222;stroke-miterlimit:10;}\n\t.st3{fill:#1410AC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.5,128.9c-1-1.6-2-3.1-3-4.7C55.2,87.7,30.9,51.1,6.7,14.5c-0.2-0.3-0.5-0.7-0.7-1c-2-3-1.8-5.3,0.6-6.9 c2.4-1.6,4.7-1,6.7,1.9c2.8,4.2,5.6,8.5,8.4,12.7c21,31.6,41.9,63.3,62.9,94.9c0.5,0.8,1.1,1.6,2.1,3c-1-6.7-1.8-12.7-2.7-18.7 c-0.2-1.1-0.3-2.1-0.4-3.2c-0.2-3,0.7-4.4,3.1-4.8c2.8-0.5,5,0.9,5.5,3.7c0.7,4.3,1.1,8.6,1.8,12.8c1.6,8.9,3.4,17.8,5.1,26.7 c0.1,0.7,0.6,1.4,1,1.9c2.1,2.5,1.2,7-1.7,8.5c-2,1.1-3.8,0.7-5.4-1c-0.9-0.9-1.9-1.8-3.1-2.3c-15.8-6.8-30.6-15.3-44.3-25.9 c-2.8-2.2-3.3-4.3-1.6-6.5c1.8-2.3,4.3-2.5,7-0.4c9,7,18.6,13.2,28.8,18.4c0.7,0.4,1.4,0.7,2.2,1C82.2,129.1,82.3,129,82.5,128.9z "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M101.5,142.3C74.6,101.5,47.7,60.8,20.9,20C17.1,14.3,13.3,8.6,9.6,2.8c-3.1-4.8-8.4,3.5-5.9,7.4 C30.6,51,57.4,91.8,84.3,132.5c3.8,5.7,7.5,11.4,11.3,17.2C98.7,154.4,104,146.2,101.5,142.3L101.5,142.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.3,96"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.6,144.5c-3.2-20.3-5.2-40.7-6.2-61.2c-0.3-5.7-9.2-1.9-9,2.8c1,20.5,3,40.9,6.2,61.2 C95.5,153,104.4,149.2,103.6,144.5L103.6,144.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M101.7,143.2c-16-7.4-32.3-14.1-48.9-20.1c-2.3-0.9-5.1-0.3-6.8,1.7c-1.2,1.5-1.8,4.5,0.6,5.4 c16.6,6.1,32.9,12.8,48.9,20.1C99.7,152.2,106.9,145.6,101.7,143.2L101.7,143.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ae528a7262541bfb70e81283963059b3.svg";
export { ForwardRef as ReactComponent };